import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { LoginInfo } from "../models/domains/pbm/user/login-info";
import { UserTenant } from "../models/domains/pbm/user/user-tenant";
import { Url } from "../models/domains/urls/url";
export class RemoteGateway {
  private defaultHeaders: HttpHeaders;

  constructor(private backendUrl: string, public httpClient: HttpClient, private loginInfo: LoginInfo, private userTenant: UserTenant) {
    this.defaultHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      loginInfo: JSON.stringify(this.loginInfo),
      "pbm-tenant-key": this.userTenant.key,
    });
  }

  postWithHeaders(url: Url, payload: any, headers: any) {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(url.getUrl(), payload, { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  putWithHeaders(url: Url, payload: any, headers: any) {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .put(url.getUrl(), payload, { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  deleteWithHeaders(url: Url, headers: any) {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .delete(url.getUrl(), { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  postWithFile(url: Url, file: File) {
    const formData = new FormData();
    formData.append("file", file);
    const headers = { loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(url.getUrl(), formData, { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }
  postWithFileWithHeaders(url: Url, file: File, headers: any) {
    const formData = new FormData();
    formData.append("file", file);
    headers.append("loginInfo", JSON.stringify(this.loginInfo));
    headers.append("pbm-tenant-key", this.userTenant.key);
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(url.getUrl(), formData, { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  postWithFileWithHeadersV2(url: Url, file: File, headers: HttpHeaders) {
    const formData = new FormData();
    formData.append("file", file);
    headers.append("loginInfo", JSON.stringify(this.loginInfo));
    headers.append("pbm-tenant-key", this.userTenant.key);
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(url.getUrl(), formData, { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  download(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(this.buildUrl(url), { responseType: "blob" as "json", headers: this.defaultHeaders })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  downloadAsGetWithHeaders(url: string): Promise<any> {
    const headers = { loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(url, { responseType: "blob" as "json", headers: headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  downloadAsPost(url: string, payload: any, headers: any): Promise<any> {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(url, payload, {
          headers,
          responseType: "blob" as "json",
        })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }


  downloadAsGet(url: Url, headers: any): Promise<any> {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(url.getUrl(), { headers, responseType: "blob" as "json" })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  get(url: Url): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(url.getUrl(), { headers: this.defaultHeaders })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  getUrlWithHeaders(url: string, headers: any): Promise<any> {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(url, { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  getWithHeaders(url: Url, headers: any): Promise<any> {
    headers = { ...headers, loginInfo: JSON.stringify(this.loginInfo), "pbm-tenant-key": this.userTenant.key };
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(url.getUrl(), { headers })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  post(url: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(this.buildUrl(url), payload, { headers: this.defaultHeaders })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  put(url: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .put(this.buildUrl(url), payload, { headers: this.defaultHeaders })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response: HttpErrorResponse) => {
          reject(response);
        });
    });
  }

  delete(url: Url) {
    return new Promise((resolve, reject) => {
      this.httpClient
        .delete(url.getUrl(), { headers: this.defaultHeaders })
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((response) => {
          reject(response);
        });
    });
  }

  private buildUrl(action: string) {
    if (!!action && action.charAt(0) !== "/") {
      action = `/${action}`;
    }
    return `${this.backendUrl}${action}`;
  }
}
